
import makerjs from "makerjs";
function B43(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,
    // L = Param[1].param,R = Param[2].param,T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       h = b,
       w = b,
       r=b/2,
       x=r,y=r,glassH = h, glassW = w;
   if (b !== 0) {
       var TxtB ="B="+ B;
   } 
   var drawAbnormalShapeB43 = {
       paths: {
        "UpLine": new makerjs.paths.Arc([r, r], r, 0,180),
        "DnLine": new makerjs.paths.Line([0, r], [b,r]),
       }
   };
   var drawAbnormalShapeB43MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, r-markShift], [b, r-markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, r], [0, r-3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, r], [b, r-3*markShift]),
       }  
   };
   makerjs.model.addCaption(drawAbnormalShapeB43MarkB, TxtB,  [0,r-2*markShift], [b, r-2*markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB43: drawAbnormalShapeB43,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB43: drawAbnormalShapeB43,
        drawAbnormalShapeB43MarkB:drawAbnormalShapeB43MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B43;